module.exports = __webpack_public_path__ + "media/images/emblems/Grangettes-coat_of_arms-f3a717b72f20af751d7b970a8d729837.svg";